import { Component, OnInit, ViewEncapsulation, HostListener, DoCheck, OnChanges, OnDestroy } from "@angular/core";
import { state, style, animate, transition, trigger, AnimationEvent } from "@angular/animations";
import { AppEditorServices } from "../../services/app-editor.services";

@Component({
  selector: 'app-editor',
  template: require('./app-editor.component.pug'),
  styles: [require('./app-editor.component.scss')],
})

export class AppEditorComponent implements OnInit, DoCheck, OnChanges, OnDestroy {
  private reset: boolean = false;
  private checked: boolean;

  constructor(
    private editor: AppEditorServices
  ){}

  ngOnChanges( changes: any ): void {}

  ngOnInit(): void {}

  ngOnDestroy() : void {}

  ngDoCheck() : void {
    const assetList = document.getElementsByClassName('asset-input');
    const selectAll = document.getElementById('select-all');
    const length = assetList.length;
    let amountSet = 0;
    if( assetList && length > 0 ) {
      for ( var i = 0; i < length ; i ++ ) {
        assetList[i]['checked'] ? amountSet ++ : null;
      }
      if ( amountSet === length && length > 0 && !selectAll['checked']) {
        selectAll['checked'] = true;
        this.checked = true;
    }
    }
    if ( selectAll && selectAll['checked'] && amountSet === 0) {
      selectAll['checked'] = false;
      this.checked = false;
    }
  }

  @HostListener( 'click', ['$event'] ) onClick ( event: any ) {
    const { id, checked } = event.target;
    const isAsset = id.match(/asset/g);
    const isSetReset = id.match(/set-values/g);
    const input = document.getElementById('select-all');

    if ( isSetReset ) {
      this.editor.clearEditor();
    }

    if ( id === 'select-all' && checked ) {
      this.checked = true;
      input['checked'] = true;
      this.editor.addAllAssets( checked );
    }

    if ( isAsset ) {
      this.checked = false;
      input['checked'] = false;
    }

    if ( id === "cancel" ) {
      this.reset = false;
    }

  }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/modules/app-editor/app-editor.component.ts